import React from "react";
import { defaultProps } from "recompose";
import {TableRow} from "@mui/material";
import StringHelper from "../../../../helpers/StringHelper";
import {TableCell} from "@mui/material";

const FullnameBloc = ({label, firstname, lastname, ...props}) => (
    <React.Fragment>
        {
            (firstname || lastname ) && <TableRow item {...props}>
            <TableCell variant="head">{label}</TableCell>
            <TableCell> : </TableCell>
            <TableCell>{StringHelper.capitalize(firstname)} <span className={"ucase"}>{lastname}</span></TableCell>
            </TableRow>
        }
    </React.Fragment>
)


FullnameBloc.withDefaultProps = defaultProps({
    firstname: "",
    lastname: "",
    label: "Nom complet",
    sm: 6,
    xs: 6,
    id: ""
})

export default FullnameBloc;
